import {hpcAttrs} from '@github-ui/hpc'
import {testIdProps} from '@github-ui/test-id-props'

import {LargerRunnerListItem} from './LargerRunnerListItem'
import {StandardGitHubHostedRunnersItem} from './StandardGitHubHostedRunnersItem'
import {EmptyState} from './EmptyState'
import {SkeletonList} from './SkeletonList'
import {RunnerList} from './RunnerList'
import {RunnerListItem} from './RunnerListItem'
import {RunnersError} from './RunnersError'

import type {GitHubHostedRunnersResponse} from '../types'
import {useRunners} from '../hooks/use-runners'

export interface GitHubHostedRunnersProps {
  fetchRunnersBasePath: string
  setUpRunnersLink?: string
}

export function GitHubHostedRunners({fetchRunnersBasePath, setUpRunnersLink, ...props}: GitHubHostedRunnersProps) {
  const {runnersResponse, isLoading, error, retry} = useRunners(`${fetchRunnersBasePath}/github_hosted_runners`)
  if (isLoading) {
    return <SkeletonList listTitle="GitHub-hosted runners list" />
  }
  if (error || !runnersResponse) {
    return <RunnersError onRetry={retry} />
  }
  const {
    largerRunners,
    showLargerRunnerBanner,
    hasHostedRunnerGroup,
    setUpRunnersLink: responseSetUpRunnersLink,
  } = runnersResponse as GitHubHostedRunnersResponse
  const effectiveSetUpRunnersLink = setUpRunnersLink ?? responseSetUpRunnersLink

  const numberOfRunners = largerRunners.length + (hasHostedRunnerGroup ? 1 : 0)
  if (numberOfRunners === 0 && !showLargerRunnerBanner) {
    return <EmptyState selectedTab="github-hosted" setUpRunnersLink={effectiveSetUpRunnersLink} />
  }

  return (
    <RunnerList
      {...hpcAttrs()}
      listTitle="GitHub-hosted runners list"
      numberOfRunners={numberOfRunners}
      {...testIdProps('github-hosted-runners')}
      {...props}
    >
      {showLargerRunnerBanner && <LargerRunnerListItem setUpRunnersLink={effectiveSetUpRunnersLink} />}
      {hasHostedRunnerGroup && <StandardGitHubHostedRunnersItem />}
      {largerRunners.map(runner => {
        return (
          <RunnerListItem
            key={runner.name}
            name={runner.name}
            os={runner.os}
            description={runner.description}
            labels={runner.labels}
            source={runner.source}
            runnerType="larger_runner"
          />
        )
      })}
    </RunnerList>
  )
}
